import { Box, Checkbox, Chip, MenuItem } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const TriggerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'isOpen' && prop !== 'customColor',
})<{ hasError?: boolean; isOpen?: boolean; customColor: string }>(
  ({ theme, hasError, isOpen, customColor }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    border: '1px solid',
    borderColor: hasError
      ? theme.palette.error.main
      : isOpen
        ? customColor
        : theme.palette.action.disabled,
    borderRadius: '0.75rem',
    cursor: 'pointer',
    backgroundColor: theme.palette.background.paper,
    minHeight: '44px',
    transition: 'all 0.2s ease-in-out',
    outline: 'none',

    '&:hover': {
      borderColor: hasError ? theme.palette.error.main : 'black',
    },

    '&:focus': {
      borderColor: '#4592fa',
      boxShadow: '0 0 0 1px #4592fa',
    },

    ...(isOpen && {
      borderColor: '#4592fa',
      boxShadow: '0 0 0 1px #4592fa',
    }),
  }),
);

export const StyledChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== 'customColor',
})<{ customColor: string }>(({ customColor }) => ({
  backgroundColor: alpha(customColor, 0.2),
  color: customColor,
  fontWeight: 600,
  borderRadius: '0.75rem',
  boxShadow: `0px 1px 2px ${alpha(customColor, 0.2)}`,
  transition: 'all 0.2s ease-in-out',
  display: 'inline-flex',
  alignItems: 'center',

  '& .MuiChip-label': {
    fontWeight: 700,
  },

  '& .MuiChip-deleteIcon': {
    color: customColor,
    transition: 'all 0.2s ease-in-out',
    width: 0,
    opacity: 0,
    margin: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    height: '100%',

    '&:hover': {
      color: customColor,
      opacity: 1,
    },
  },

  '&:hover': {
    paddingRight: '8px',
    '& .MuiChip-deleteIcon': {
      width: '16px',
      opacity: 0.7,
      marginLeft: '4px',
      pointerEvents: 'auto',
    },
  },
}));

export const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'customColor',
})<{ customColor: string }>(({ customColor }) => ({
  color: '#9e9e9e',
  '&.Mui-checked': {
    color: customColor,
  },
  '&.MuiCheckbox-indeterminate': {
    color: customColor,
  },
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  minHeight: 'auto',
  '& .MuiListItemIcon-root': {
    minWidth: 20,
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.75rem',
  },
}));
